import { render, staticRenderFns } from "./ESGScopeConversion.vue?vue&type=template&id=8d82d57a"
import script from "./ESGScopeConversion.vue?vue&type=script&lang=js"
export * from "./ESGScopeConversion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports